var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVal3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2400_36150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25488 43.417C5.10287 40.569 8.48393 38.3099 12.205 36.7685C15.9261 35.2272 19.9143 34.4339 23.942 34.4339C27.9696 34.4339 31.9579 35.2273 35.6789 36.7686C39.4 38.3099 42.7811 40.5691 45.629 43.4171V43.4171C33.6516 55.3945 14.2323 55.3944 2.25488 43.417V43.417Z",
    fill: "#47BDFF"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.19602,
    transform: "matrix(0.707113 -0.707101 0.707113 0.707101 5.34834 30.9927)",
    fill: "#FDB52A"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.19602,
    transform: "matrix(0.707113 -0.707101 0.707113 0.707101 42.5358 30.9927)",
    fill: "#FDB52A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.9419,
    cy: 21.73,
    r: 9.70858,
    transform: "rotate(-45 23.9419 21.73)",
    fill: "#FDB52A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_36150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVal3);
export default __webpack_public_path__ + "static/media/val3.07de912992ea554dc366fea2dbdffac6.svg";
export { ForwardRef as ReactComponent };